import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/admin/page.tsx");
